import { Temporal } from 'temporal-polyfill'
import { createSelector } from '@reduxjs/toolkit'
import { map, reduce, first, last, sortBy } from 'lodash'
import TimetoastTemporal from '@base/timetoast_temporal.js'

export function getHorizontalVizBase(state) {
  return state
}

export const firstAndLastDateSelector = createSelector(
  (state, props) => props.markers,
  (state, props) => props.timespans,
  function (markersList, timespansList) {
    const sortableObjFn = timetoastTemporal => timetoastTemporal.getTime()
    const numItems = markersList.length + timespansList.length
    if (numItems === 0) {
      return [null, null]
    } else if (numItems === 1) {
      if (markersList.length === 1) {
        const markerTemporal = TimetoastTemporal.parse(markersList[0].date)
        return [markerTemporal, markerTemporal]
      } else if (timespansList.length === 1) {
        const timespan = timespansList[0]
        const sortedDates = sortBy(
          [TimetoastTemporal.parse(timespan.start_date), TimetoastTemporal.parse(timespan.end_date)],
          [sortableObjFn]
        )
        return sortedDates
      }
    } else {
      const markerDatesList = map(markersList, marker => TimetoastTemporal.parse(marker.date))
      const timespanDatesList = reduce(
        timespansList,
        (result, value, key) => {
          // Note: value here is a timespan
          result.push(TimetoastTemporal.parse(value.start_date))
          result.push(TimetoastTemporal.parse(value.end_date))
          return result
        },
        []
      )
      const allDatesList = markerDatesList.concat(timespanDatesList)
      const sortedDatesList = sortBy(allDatesList, [sortableObjFn])
      return [first(sortedDatesList), last(sortedDatesList)]
    }
  }
)

export const durationSelector = createSelector(firstAndLastDateSelector, function (firstAndLastDate) {
  let startTemporal = first(firstAndLastDate)
  let endTemporal = last(firstAndLastDate)
  if (startTemporal && endTemporal) {
    let startTime = startTemporal.getTime()
    let endTime = endTemporal.getTime()
    let duration = endTime - startTime
    return {
      startTime,
      endTime,
      duration,
    }
  } else {
    const now = Temporal.Now.instant().epochMilliseconds
    return {
      startTime: now,
      endTime: now,
      duration: 0,
    }
  }
})
